import { render, staticRenderFns } from "./select.vue?vue&type=template&id=d8e8af1a&scoped=true&"
import script from "./select.vue?vue&type=script&lang=js&"
export * from "./select.vue?vue&type=script&lang=js&"
import style0 from "./select.vue?vue&type=style&index=0&id=d8e8af1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8e8af1a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\mzkj\\要炼\\yl-pc-business\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d8e8af1a')) {
      api.createRecord('d8e8af1a', component.options)
    } else {
      api.reload('d8e8af1a', component.options)
    }
    module.hot.accept("./select.vue?vue&type=template&id=d8e8af1a&scoped=true&", function () {
      api.rerender('d8e8af1a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/trade/addTrade/select.vue"
export default component.exports